import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { AppRoutes } from "./router";
import ScrollToTop from "./router/ScrollToTop";
import Loading from "./components/base/Loading";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <Suspense fallback={<Loading />}>
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
